// Packages:
import React from 'react'
import {
    OutlinedInput, 
    InputAdornment, 
    FormControl,
    styled,
    Select,
    MenuItem,
    Checkbox,
    ListItemText
  } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { EVENT_TYPES } from '../../../constants/events';


// Styles:
const StyledFormControl = styled(FormControl)`
  font-size: 14px;
  background: #FFFFFF;
  & .MuiOutlinedInput-root {
    font-size: 14px;
  }
`;


// Functions:
export const ColumnFilter = ({ column }) => {
    // Constants:
    const { filterValue, setFilter, Header: header } = column

    // Return:
    if(header === "Event"){
        return (
            <>
                <FormControl variant="outlined" >
                    <Select
                        multiple
                        id="sentiments-outlined"
                        value={filterValue || []}
                        onChange={(e) => setFilter(e.target.value?.length == 0 ? "" : e.target.value)}
                        sx={{ minWidth: 100, height: 37, backgroundColor: "white", maxWidth: 140 }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
                        renderValue={(selected) => selected.join(', ')}
                    >
                        {Object.entries(EVENT_TYPES).filter(([key, value]) => value !== EVENT_TYPES.WIDGET_READY_EVENT && value !== EVENT_TYPES.WIDGET_AUTO_LAUNCH_EVENT).map(([key, value]) => (
                            <MenuItem key={key} value={value}>
                                <Checkbox checked={!!filterValue?.includes(value)} />
                                <ListItemText primary={value} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </>
        )
    }
    return (
        <span>
            <StyledFormControl variant="outlined">
                <OutlinedInput
                    type="text"
                    value={filterValue || ''}
                    onChange={(e) => setFilter(e.target.value)}
                    placeholder="Filter"
                    endAdornment={
                        <InputAdornment position="end">
                            <SearchOutlinedIcon sx={{ fontSize: '20px' }} />
                        </InputAdornment>
                    }
                    size="small"
                />
            </StyledFormControl>
        </span>
    )
}